export default __webpack_public_path__ + "static/media/contact.e79c2b4d.svg";